import React from "react";

export const rightArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{ fill: "var(--ion-color-white)" }}
  >
    <path
      id="arrow-right-circle-fill"
      className="cls-1"
      d="M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0ZM4.5,7.5a.5.5,0,0,0,0,1h5.793L8.146,10.646a.5.5,0,1,0,.708.708l3-3a.5.5,0,0,0,0-.708l-3-3a.5.5,0,1,0-.708.708L10.293,7.5Z"
    />
  </svg>
);

export const leftArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{ fill: "var(--ion-color-white)" }}
  >
    <path
      id="arrow-left-circle-fill"
      className="cls-1"
      d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm3.5,7.5a.5.5,0,0,1,0,1H5.707l2.147,2.146a.5.5,0,1,1-.708.708l-3-3a.5.5,0,0,1,0-.708l3-3a.5.5,0,0,1,.708.708L5.707,7.5Z"
    />
  </svg>
);

export const xSign = (
  size = 24,
  backgroundFill = "#ac1b1b",
  symbolFill = "var(--ion-color-white)"
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <path
      d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
      fill={backgroundFill}
      style={{ width: size, height: size }}
    />
    <path
      fill={symbolFill}
      strokeWidth={size}
      stroke={symbolFill}
      d="M320 320L192 192M192 320l128-128"
    />
  </svg>
);

export const search_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33.434"
    height="33.439"
    viewBox="0 0 33.434 33.439"
  >
    <path
      id="Icon_awesome-search"
      data-name="Icon awesome-search"
      d="M32.979,28.91,26.468,22.4a1.566,1.566,0,0,0-1.11-.457H24.293a13.577,13.577,0,1,0-2.351,2.351v1.064a1.566,1.566,0,0,0,.457,1.11l6.511,6.511a1.561,1.561,0,0,0,2.214,0l1.848-1.848A1.575,1.575,0,0,0,32.979,28.91Zm-19.4-6.968a8.359,8.359,0,1,1,8.359-8.359A8.354,8.354,0,0,1,13.583,21.942Z"
      fill="var(--ion-color-white)"
    />
  </svg>
);

export const home_icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="ionicon"
    viewBox="0 0 512 512"
    style={{
      fill: "var(--ion-color-primary)",
      width: "87px",
      aspectRatio: "64/72",
    }}
  >
    <path d="M80 480a16 16 0 01-16-16V68.13a24 24 0 0111.9-20.72C88 40.38 112.38 32 160 32c37.21 0 78.83 14.71 115.55 27.68C305.12 70.13 333.05 80 352 80a183.84 183.84 0 0071-14.5 18 18 0 0125 16.58v219.36a20 20 0 01-12 18.31c-8.71 3.81-40.51 16.25-84 16.25-24.14 0-54.38-7.14-86.39-14.71C229.63 312.79 192.43 304 160 304c-36.87 0-55.74 5.58-64 9.11V464a16 16 0 01-16 16z" />
  </svg>
);

// NEW DESIGN

export const ServiceOptionIcons = {
  Breakfast: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.286"
      height="22.166"
      viewBox="0 0 14.807 14.807"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <path
        id="Icon_material-free-breakfast"
        data-name="Icon material-free-breakfast"
        className="cls-1"
        d="M19.161,4.5H6v8.226a3.289,3.289,0,0,0,3.29,3.29h4.936a3.289,3.289,0,0,0,3.29-3.29V10.258h1.645a1.645,1.645,0,0,0,1.645-1.645V6.145A1.639,1.639,0,0,0,19.161,4.5Zm0,4.113H17.516V6.145h1.645ZM6,17.661H19.161v1.645H6Z"
        transform="translate(-6 -4.5)"
      />
    </svg>
  ),
  Dinner: (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      width="25.286"
      height="22.166"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <path d="m217.89,247.85c0,13.37-10.84,24.21-24.21,24.21-13.37,0-24.21-10.84-24.21-24.21v-.06s.5-58.33.5-58.33c.04-5.72,2.33-11.19,6.38-15.23l1.78-1.78c1.35-1.36,2.11-3.18,2.13-5.09l-.28-7.04c-.07-1.82-.82-3.55-2.11-4.84-.45-.43-.94-.82-1.48-1.13-2.15-1.25-4.12-2.78-5.87-4.53-5.51-5.52-8.61-12.99-8.61-20.78v-54.88c-.02-22.56,8.29-44.83,21.61-58.1,8.05-8.05,17.45-12.26,27.13-12.21,4,.02,7.24,3.27,7.24,7.28v111.3c0,.22.03.43.11.64v37.46c-.08.19-.12.4-.12.63v86.7Z" />
      <path d="m135.49,17.78c-4.15-.18-7.67,3.03-7.86,7.18,0,.12-.01.24,0,.37l.16,45.62c.01,3.18-2.56,5.78-5.75,5.8-3.18.02-5.8-2.74-5.8-5.92l-.19-45.44c-.02-4.15-3.4-7.51-7.55-7.49-.13,0-.24,0-.37,0-1.84.1-3.57.88-4.86,2.19-1.46,1.48-2.28,3.48-2.28,5.57l.18,45.39c.01,3.18-2.56,5.78-5.75,5.8-3.18.01-5.8-2.74-5.81-5.93l-.17-45.43c-.01-4.15-3.39-7.51-7.55-7.49-.12,0-.24,0-.36.01-1.84.1-3.57.87-4.86,2.19-1.46,1.48-2.28,3.48-2.27,5.56l.2,51.17c0,9.98,4.01,19.55,11.12,26.56l2.75,2.72c1.42,1.41,2.22,3.32,2.23,5.32l.09,22.93-2.24,70.11.06,44.01c.03,7.87,4.44,15.04,12.07,18.73.43.21.87.39,1.32.54,7.99,2.71,16.18.71,21.72-4.87,3.86-3.87,6-9.12,5.96-14.58l-.37-58.99-2.2-55.11-.09-22.93c0-2,.77-3.91,2.18-5.33l2.74-2.76c7.05-7.07,10.98-16.66,10.91-26.64l-.18-51.19c.03-4.06-3.13-7.44-7.19-7.7Z" />
    </svg>
  ),
  DiningParty: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 495 422"
      width="25.286"
      height="22.166"
    >
      <path
        style={{ fill: "var(--ion-color-primary)" }}
        d="M336 256c-20.56 0-40.44-9.18-56-25.84-15.13-16.25-24.37-37.92-26-61-1.74-24.62 5.77-47.26 21.14-63.76S312 80 336 80c23.83 0 45.38 9.06 60.7 25.52 15.47 16.62 23 39.22 21.26 63.63-1.67 23.11-10.9 44.77-26 61C376.44 246.82 356.57 256 336 256zm66-88zM467.83 432H204.18a27.71 27.71 0 01-22-10.67 30.22 30.22 0 01-5.26-25.79c8.42-33.81 29.28-61.85 60.32-81.08C264.79 297.4 299.86 288 336 288c36.85 0 71 9 98.71 26.05 31.11 19.13 52 47.33 60.38 81.55a30.27 30.27 0 01-5.32 25.78A27.68 27.68 0 01467.83 432zM147 260c-35.19 0-66.13-32.72-69-72.93-1.42-20.6 5-39.65 18-53.62 12.86-13.83 31-21.45 51-21.45s38 7.66 50.93 21.57c13.1 14.08 19.5 33.09 18 53.52-2.87 40.2-33.8 72.91-68.93 72.91zM212.66 291.45c-17.59-8.6-40.42-12.9-65.65-12.9-29.46 0-58.07 7.68-80.57 21.62-25.51 15.83-42.67 38.88-49.6 66.71a27.39 27.39 0 004.79 23.36A25.32 25.32 0 0041.72 400h111a8 8 0 007.87-6.57c.11-.63.25-1.26.41-1.88 8.48-34.06 28.35-62.84 57.71-83.82a8 8 0 00-.63-13.39c-1.57-.92-3.37-1.89-5.42-2.89z"
      />
    </svg>
  ),
  Entertainment: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.989"
      height="20.5"
      viewBox="0 0 24.989 20.5"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <g id="Layer_2" data-name="Layer 2" transform="translate(0 0)">
        <g id="Layer_2-2" data-name="Layer 2" transform="translate(0 0)">
          <path
            id="Path_229"
            data-name="Path 229"
            className="cls-1"
            d="M12.371.362a.556.556,0,0,0-.664-.355l-3,.711A27.805,27.805,0,0,0,3.1,2.632L.353,3.93a.541.541,0,0,0-.34.711l2.518,7.168A5.592,5.592,0,0,0,7,15.454l2.92.494a5.9,5.9,0,0,1-.232-3.738l.216-.772L6.346,12.7A3.414,3.414,0,0,1,8.555,8.58,2.95,2.95,0,0,1,10.61,8.8l1.282-4.634a.6.6,0,0,1,.7-.417l.973.154ZM4.941,8.085A1.174,1.174,0,0,1,3.4,7.359a1.159,1.159,0,0,1,.726-1.468A1.143,1.143,0,0,1,5.667,6.6a1.159,1.159,0,0,1-.741,1.483Zm5.546-1.9a1.159,1.159,0,0,1-1.545-.726,1.143,1.143,0,0,1,.711-1.545,1.159,1.159,0,0,1,1.545.711,1.189,1.189,0,0,1-.711,1.56Z"
            transform="translate(0.024 0.012)"
          />
          <path
            id="Path_230"
            data-name="Path 230"
            className="cls-1"
            d="M20.978,6.126l-2.858-1.1A27.9,27.9,0,0,0,12.4,3.484l-2.085-.448-.927-.093a.541.541,0,0,0-.618.371L7.616,7.562,7.06,9.555l-.294,1.2a5.391,5.391,0,0,0,.309,3.677A5.947,5.947,0,0,0,8.4,16.29l2.209,2.132a1.684,1.684,0,0,0,1.545.417l2.981-.726a5.592,5.592,0,0,0,4.2-3.939l2.008-7.368A.556.556,0,0,0,20.978,6.126ZM10.165,7.67a1.159,1.159,0,0,1,1.251-.85h.17a1.159,1.159,0,0,1-.247,2.271.9.9,0,0,1-.355,0A1.159,1.159,0,0,1,10.2,7.562Zm2.441,8.048a3.259,3.259,0,0,1-2.533-3.831l6.1,1.545a3.229,3.229,0,0,1-3.537,2.178Zm5.484-5.9a1.089,1.089,0,1,1,.031-.108Z"
            transform="translate(3.62 1.616)"
          />
        </g>
      </g>
    </svg>
  ),
  Activities: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.328"
      height="22.688"
      viewBox="0 0 25.328 22.688"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <path
        id="Icon_material-directions-bike"
        data-name="Icon material-directions-bike"
        className="cls-1"
        d="M16.358,6.677a2.17,2.17,0,0,0,2.111-2.213,2.113,2.113,0,1,0-4.221,0A2.17,2.17,0,0,0,16.358,6.677ZM5.277,13.871A5.357,5.357,0,0,0,0,19.4a5.357,5.357,0,0,0,5.277,5.534A5.357,5.357,0,0,0,10.553,19.4,5.357,5.357,0,0,0,5.277,13.871Zm0,9.407a3.878,3.878,0,0,1,0-7.747,3.878,3.878,0,0,1,0,7.747ZM11.4,12.211,13.93,9.554l.844.885a7.226,7.226,0,0,0,5.382,2.324V10.55a5.127,5.127,0,0,1-3.8-1.66l-2.005-2.1a2.518,2.518,0,0,0-1.689-.664,1.736,1.736,0,0,0-1.477.664l-2.955,3.1A2.238,2.238,0,0,0,7.6,11.436a1.9,1.9,0,0,0,.633,1.549l3.377,3.1v5.534h2.111V14.756L11.4,12.211Zm8.654,1.66A5.357,5.357,0,0,0,14.775,19.4a5.283,5.283,0,1,0,10.553,0A5.357,5.357,0,0,0,20.051,13.871Zm0,9.407a3.878,3.878,0,0,1,0-7.747,3.878,3.878,0,0,1,0,7.747Z"
        transform="translate(0 -2.25)"
      />
    </svg>
  ),
  Treats: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <path
        id="Icon_ionic-md-wine"
        data-name="Icon ionic-md-wine"
        className="cls-1"
        d="M12.5,14.5v6.125h-5V22.5h12V20.625h-5V14.5l8-8v-2H4.5v2ZM9,8.5l-2-2H20l-2,2Z"
        transform="translate(-4.5 -4.5)"
      />
    </svg>
  ),
  Golf: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.7"
      height="22"
      viewBox="0 0 18.7 22"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <g
        id="Icon_material-golf-course"
        data-name="Icon material-golf-course"
        transform="translate(-6 -3)"
      >
        <path
          id="Path_300"
          data-name="Path 300"
          className="cls-1"
          d="M30.3,28.65A1.65,1.65,0,1,1,28.65,27,1.65,1.65,0,0,1,30.3,28.65Z"
          transform="translate(-5.6 -6.4)"
        />
        <path
          id="Path_301"
          data-name="Path 301"
          className="cls-1"
          d="M20.3,7.312,11.5,3V22.8H9.3V20.9C7.331,21.282,6,21.986,6,22.8,6,24.01,8.959,25,12.6,25s6.6-.99,6.6-2.2c0-1.089-2.376-1.991-5.5-2.167V10.678Z"
        />
      </g>
    </svg>
  ),
  Spas: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="14"
      viewBox="0 0 18 14"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <g id="Group_1373" data-name="Group 1373" transform="translate(0)">
        <path
          id="Icon_awesome-spa"
          data-name="Icon awesome-spa"
          className="cls-1"
          d="M17.758,7.25a9.994,9.994,0,0,0-6.682,2.594A8.03,8.03,0,0,0,9,12.808,8.03,8.03,0,0,0,6.925,9.844,9.994,9.994,0,0,0,.242,7.25.238.238,0,0,0,0,7.494a8.654,8.654,0,0,0,2.774,6.228A8.294,8.294,0,0,0,9,16.25a8.294,8.294,0,0,0,6.226-2.527A8.653,8.653,0,0,0,18,7.494a.238.238,0,0,0-.242-.244ZM9,10.706a8.6,8.6,0,0,1,1.378-1.579A9.352,9.352,0,0,1,12.26,7.715,10.308,10.308,0,0,0,9.237,2.334a.375.375,0,0,0-.473,0A10.308,10.308,0,0,0,5.741,7.711,9.188,9.188,0,0,1,7.592,9.1,8.836,8.836,0,0,1,9,10.706Z"
          transform="translate(0 -2.25)"
        />
      </g>
    </svg>
  ),
  Explore: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.717"
      height="25.717"
      viewBox="0 0 25.717 25.717"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <path
        id="Icon_awesome-map-signs"
        data-name="Icon awesome-map-signs"
        className="cls-1"
        d="M25.481,4.254,23.306,2.078a1.607,1.607,0,0,0-1.137-.471h-7.7V.8a.8.8,0,0,0-.8-.8H12.055a.8.8,0,0,0-.8.8v.8H2.813A1.206,1.206,0,0,0,1.607,2.813V6.831A1.206,1.206,0,0,0,2.813,8.036H22.169a1.608,1.608,0,0,0,1.137-.471L25.481,5.39A.8.8,0,0,0,25.481,4.254ZM11.251,24.913a.8.8,0,0,0,.8.8h1.607a.8.8,0,0,0,.8-.8V19.288H11.251ZM22.9,11.251H14.466V9.644H11.251v1.607h-7.7a1.608,1.608,0,0,0-1.137.471L.236,13.9a.8.8,0,0,0,0,1.137L2.411,17.21a1.607,1.607,0,0,0,1.137.471H22.9a1.206,1.206,0,0,0,1.205-1.205V12.457A1.206,1.206,0,0,0,22.9,11.251Z"
        transform="translate(0)"
      />
    </svg>
  ),
  Experiences: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.885"
      height="22.625"
      viewBox="0 0 20.885 22.625"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <path
        id="Icon_ionic-md-flower"
        data-name="Icon ionic-md-flower"
        className="cls-1"
        d="M23.051,14.688a4.027,4.027,0,0,0-1.746-7.679,4.1,4.1,0,0,0-2.317.712l.033-.3a4.079,4.079,0,0,0-8.158,0l.033.3a4.049,4.049,0,1,0-4.063,6.967,4.027,4.027,0,0,0,1.746,7.679,4.1,4.1,0,0,0,2.317-.712l-.033.3a4.079,4.079,0,0,0,8.158,0l-.033-.3a4.049,4.049,0,1,0,4.063-6.967Zm-8.109,4.041a4.041,4.041,0,1,1,4.079-4.041A4.062,4.062,0,0,1,14.942,18.728Z"
        transform="translate(-4.5 -3.375)"
      />
    </svg>
  ),
  RegisterCard: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.023"
      height="17.907"
      viewBox="0 0 23.023 17.907"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <path
        id="Icon_awesome-credit-card"
        data-name="Icon awesome-credit-card"
        className="cls-1"
        d="M0,18.238a1.919,1.919,0,0,0,1.919,1.919H21.1a1.919,1.919,0,0,0,1.919-1.919V11.2H0ZM7.674,15.52a.481.481,0,0,1,.48-.48H13.59a.481.481,0,0,1,.48.48v1.6a.481.481,0,0,1-.48.48H8.154a.481.481,0,0,1-.48-.48Zm-5.116,0a.481.481,0,0,1,.48-.48H5.916a.481.481,0,0,1,.48.48v1.6a.481.481,0,0,1-.48.48H3.038a.481.481,0,0,1-.48-.48ZM23.023,4.169V6.087H0V4.169A1.919,1.919,0,0,1,1.919,2.25H21.1A1.919,1.919,0,0,1,23.023,4.169Z"
        transform="translate(0 -2.25)"
      />
    </svg>
  ),
  CheckInEssentials: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.421"
      height="15.316"
      viewBox="0 0 20.421 15.316"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <path
        id="Icon_awesome-concierge-bell"
        data-name="Icon awesome-concierge-bell"
        className="cls-1"
        d="M11.487,7.154V6.414h.638a.638.638,0,0,0,.638-.638V5.138a.638.638,0,0,0-.638-.638H8.3a.638.638,0,0,0-.638.638v.638a.638.638,0,0,0,.638.638h.638v.739a8.929,8.929,0,0,0-7.658,8.833H19.145A8.929,8.929,0,0,0,11.487,7.154Zm8.3,10.109H.638A.638.638,0,0,0,0,17.9v1.276a.638.638,0,0,0,.638.638H19.783a.638.638,0,0,0,.638-.638V17.9A.638.638,0,0,0,19.783,17.263Z"
        transform="translate(0 -4.5)"
      />
    </svg>
  ),
  RoomAccount: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.495"
      height="23.271"
      viewBox="0 0 26.495 23.271"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <path
        id="Icon_ionic-md-key"
        data-name="Icon ionic-md-key"
        className="cls-1"
        d="M14.934,14.824a6.3,6.3,0,0,0-5.756-4.136,5.847,5.847,0,0,0-5.8,5.975,5.943,5.943,0,0,0,5.917,5.975A6.141,6.141,0,0,0,14.934,18.5H20.84v3.677h3.97V18.5h2.465V14.824Zm-5.607,3.82a1.982,1.982,0,1,1,1.982-1.982A1.986,1.986,0,0,1,9.327,18.644Z"
        transform="translate(-8.774 6.391) rotate(-34)"
      />
    </svg>
  ),
  WhatsOnGuide: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.874"
      height="22.082"
      viewBox="0 0 19.874 22.082"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <path
        id="Icon_material-event-note"
        data-name="Icon material-event-note"
        className="cls-1"
        d="M19.957,11.437H8.916v2.208H19.957Zm2.208-7.729h-1.1V1.5H18.853V3.708H10.021V1.5H7.812V3.708h-1.1a2.2,2.2,0,0,0-2.2,2.208L4.5,21.374a2.208,2.208,0,0,0,2.208,2.208H22.166a2.215,2.215,0,0,0,2.208-2.208V5.916A2.215,2.215,0,0,0,22.166,3.708Zm0,17.666H6.708V9.229H22.166Zm-5.521-5.521H8.916v2.208h7.729Z"
        transform="translate(-4.5 -1.5)"
      />
    </svg>
  ),
  Map: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.154"
      height="20.342"
      viewBox="0 0 26.154 20.342"
      style={{ fill: "var(--ion-color-primary)" }}
    >
      <path
        id="Icon_awesome-map"
        data-name="Icon awesome-map"
        className="cls-1"
        d="M0,6.139V21.864a.727.727,0,0,0,1,.675l6.269-2.853V2.25L.914,4.79A1.453,1.453,0,0,0,0,6.139ZM8.718,19.686l8.718,2.906V5.156L8.718,2.25ZM25.158,2.3,18.889,5.156V22.592l6.351-2.54a1.453,1.453,0,0,0,.914-1.349V2.977A.727.727,0,0,0,25.158,2.3Z"
        transform="translate(0 -2.25)"
      />
    </svg>
  ),
  Itinerary: (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 300 300"
    >
      <path
        id="clipboard"
        style={{ fill: "var(--ion-color-primary)" }}
        d="m208.56,21.39h-6.19c-1.78,0-3.36-1.08-4-2.73-3.4-8.77-11.8-14.53-21.19-14.55h-58.1c-9.37.04-17.75,5.8-21.13,14.53-.65,1.65-2.25,2.73-4.03,2.73h-6.23c-19.05,0-34.49,15.46-34.49,34.49v172.67c0,19.05,15.44,34.49,34.49,34.49h120.84c19.05,0,34.49-15.44,34.49-34.49V55.89c.02-19.03-15.39-34.49-34.44-34.51Zm-115.17,200.03c-5.97,0-10.82-4.85-10.82-10.82s4.85-10.82,10.82-10.82,10.82,4.85,10.82,10.82-4.85,10.82-10.82,10.82Zm0-51.96c-5.97,0-10.82-4.85-10.82-10.82s4.85-10.82,10.82-10.82,10.82,4.85,10.82,10.82-4.85,10.82-10.82,10.82Zm0-54.12c-5.97,0-10.82-4.85-10.82-10.82s4.85-10.82,10.82-10.82,10.82,4.85,10.82,10.82-4.85,10.82-10.82,10.82Zm11.65-68.1c0-4.76,3.85-8.64,8.64-8.64h68.91c4.76,0,8.62,3.87,8.62,8.64s-3.85,8.64-8.62,8.64h-68.91c-4.78,0-8.64-3.87-8.64-8.64Zm109.58,169.55c0,1.36-1.1,2.47-2.47,2.47h-92.48c-1.36,0-2.47-1.1-2.47-2.47v-12.38c0-1.36,1.1-2.47,2.47-2.47h92.48c1.36,0,2.47,1.1,2.47,2.47v12.38Zm0-51.96c0,1.36-1.1,2.47-2.47,2.47h-92.48c-1.36,0-2.47-1.1-2.47-2.47v-12.38c0-1.36,1.1-2.47,2.47-2.47h92.48c1.36,0,2.47,1.1,2.47,2.47v12.38Zm0-54.12c0,1.36-1.1,2.47-2.47,2.47h-92.48c-1.36,0-2.47-1.1-2.47-2.47v-12.38c0-1.36,1.1-2.47,2.47-2.47h92.48c1.36,0,2.47,1.1,2.47,2.47v12.38Z"
      />
    </svg>
  ),
};

export const PriceTag = (size = 15, fill) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 31.99"
    style={{ fill: fill }}
  >
    <path
      id="Icon_ionic-md-pricetag"
      data-name="Icon ionic-md-pricetag"
      d="M33.832,4.5h-13.2L5.542,20.133a3.538,3.538,0,0,0,0,5.016l10.308,10.3a3.825,3.825,0,0,0,2.4,1.042,4.179,4.179,0,0,0,2.617-1.042L36.5,20.5V7.167Zm-2.558,8.558a2.669,2.669,0,1,1,1.783-1.783A2.6,2.6,0,0,1,31.274,13.058Z"
      transform="translate(-4.499 -4.5)"
    />
  </svg>
);

export const CheckCircle = (size, scale) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ fill: "var(--ion-color-success)" }}
      id="d9090658-f907-4d85-8bc1-743b70378e93"
      data-name="Livello 1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>prime</title>
      <path
        transform={`scale(${scale})`}
        id="70fa6808-131f-4233-9c3a-fc089fd0c1c4"
        data-name="done circle"
        d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM11.52,17L6,12.79l1.83-2.37L11.14,13l4.51-5.08,2.24,2Z"
      />
    </svg>
  );
};

export const addToCalendar = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 300 300"
  >
    <path
      style={{ fill: "var(--ion-color-white)" }}
      d="m295.77,77.53c0,29.3-17.02,54.72-41.7,66.85-9.89,4.88-21.02,7.61-32.76,7.61-34.83,0-64.15-24.04-72.23-56.4-1.43-5.65-2.19-11.56-2.22-17.64v-.42c0-16.28,5.25-31.36,14.16-43.62,13.53-18.66,35.52-30.83,60.29-30.83,41.06,0,74.46,33.4,74.46,74.45Z"
    />
    <g>
      <path
        id="calendar-clear"
        style={{ fill: fill }}
        d="m221.05,166.22c-42.85,0-78.62-30.29-87.06-70.63H9.55c-1.23,0-2.21.98-2.21,2.19v129.98c0,19.46,15.78,35.24,35.25,35.24h176.22c19.47,0,35.26-15.78,35.26-35.24v-67.87c-10.21,4.08-21.35,6.33-33.02,6.33ZM143.38,33.91h-74.36v-8.57c.04-4.77-3.63-8.73-8.38-9.05-4.87-.23-9,3.51-9.22,8.38-.02.14-.02.28-.02.43v8.81h-8.81c-19.47,0-35.25,15.78-35.25,35.23v6.62c0,1.21.98,2.19,2.21,2.19h122.56c-.01-.23-.01-.45-.01-.68,0-15.75,4.09-30.54,11.28-43.36Z"
      />
      <path
        style={{ fill: fill }}
        d="m221.31,3.08c-24.77,0-46.76,12.17-60.29,30.83-8.91,12.26-14.16,27.34-14.16,43.62v.42c.03,6.08.79,11.99,2.22,17.64,8.08,32.36,37.4,56.4,72.23,56.4,11.74,0,22.87-2.73,32.76-7.61,24.68-12.13,41.7-37.55,41.7-66.85,0-41.05-33.4-74.45-74.46-74.45Zm28.63,80.18h-22.9v22.9c0,3.18-2.56,5.74-5.73,5.74s-5.73-2.56-5.73-5.74v-22.9h-22.91c-3.02,0-5.48-2.33-5.71-5.31-.01-.14-.01-.28-.01-.42,0-3.16,2.56-5.72,5.72-5.72h22.91v-22.92c0-3.16,2.57-5.72,5.73-5.72s5.73,2.56,5.73,5.72v22.92h22.9c1.62,0,3.09.66,4.13,1.75.99,1.02,1.61,2.42,1.61,3.97,0,3.17-2.57,5.73-5.74,5.73Z"
      />
    </g>
  </svg>
);

export const dinner = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 300 300"
  >
    <path
      style={{ fill: fill }}
      d="m217.89,247.85c0,13.37-10.84,24.21-24.21,24.21-13.37,0-24.21-10.84-24.21-24.21v-.06s.5-58.33.5-58.33c.04-5.72,2.33-11.19,6.38-15.23l1.78-1.78c1.35-1.36,2.11-3.18,2.13-5.09l-.28-7.04c-.07-1.82-.82-3.55-2.11-4.84-.45-.43-.94-.82-1.48-1.13-2.15-1.25-4.12-2.78-5.87-4.53-5.51-5.52-8.61-12.99-8.61-20.78v-54.88c-.02-22.56,8.29-44.83,21.61-58.1,8.05-8.05,17.45-12.26,27.13-12.21,4,.02,7.24,3.27,7.24,7.28v111.3c0,.22.03.43.11.64v37.46c-.08.19-.12.4-.12.63v86.7Z"
    />
    <path
      style={{ fill: fill }}
      d="m135.49,17.78c-4.15-.18-7.67,3.03-7.86,7.18,0,.12-.01.24,0,.37l.16,45.62c.01,3.18-2.56,5.78-5.75,5.8-3.18.02-5.8-2.74-5.8-5.92l-.19-45.44c-.02-4.15-3.4-7.51-7.55-7.49-.13,0-.24,0-.37,0-1.84.1-3.57.88-4.86,2.19-1.46,1.48-2.28,3.48-2.28,5.57l.18,45.39c.01,3.18-2.56,5.78-5.75,5.8-3.18.01-5.8-2.74-5.81-5.93l-.17-45.43c-.01-4.15-3.39-7.51-7.55-7.49-.12,0-.24,0-.36.01-1.84.1-3.57.87-4.86,2.19-1.46,1.48-2.28,3.48-2.27,5.56l.2,51.17c0,9.98,4.01,19.55,11.12,26.56l2.75,2.72c1.42,1.41,2.22,3.32,2.23,5.32l.09,22.93-2.24,70.11.06,44.01c.03,7.87,4.44,15.04,12.07,18.73.43.21.87.39,1.32.54,7.99,2.71,16.18.71,21.72-4.87,3.86-3.87,6-9.12,5.96-14.58l-.37-58.99-2.2-55.11-.09-22.93c0-2,.77-3.91,2.18-5.33l2.74-2.76c7.05-7.07,10.98-16.66,10.91-26.64l-.18-51.19c.03-4.06-3.13-7.44-7.19-7.7Z"
    />
  </svg>
);

export const itineraryOutlined = (
  width = 24,
  height = 24,
  fill = "var(--ion-color-white)",
  strokeWidth = "5"
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 63.191 87.254"
  >
    <g
      id="Itinerary_icon_outlined"
      data-name="Itinerary icon outlined"
      transform="translate(1 1)"
    >
      <path
        id="Icon_awesome-clipboard-list"
        data-name="Icon awesome-clipboard-list"
        style={{
          fill: "none",
          stroke: fill,
          strokeWidth: strokeWidth,
        }}
        d="M55.292,10.532H42.127a10.532,10.532,0,1,0-21.064,0H7.9a7.9,7.9,0,0,0-7.9,7.9V76.356a7.9,7.9,0,0,0,7.9,7.9H55.292a7.9,7.9,0,0,0,7.9-7.9V18.431A7.9,7.9,0,0,0,55.292,10.532ZM15.8,69.773a3.949,3.949,0,1,1,3.949-3.949A3.94,3.94,0,0,1,15.8,69.773Zm0-15.8a3.949,3.949,0,1,1,3.949-3.949A3.94,3.94,0,0,1,15.8,53.975Zm0-15.8a3.949,3.949,0,1,1,3.949-3.949A3.94,3.94,0,0,1,15.8,38.178Zm15.8-31.6a3.949,3.949,0,1,1-3.949,3.949A3.94,3.94,0,0,1,31.6,6.582ZM52.659,67.14a1.32,1.32,0,0,1-1.316,1.316h-23.7a1.32,1.32,0,0,1-1.316-1.316V64.507a1.32,1.32,0,0,1,1.316-1.316h23.7a1.32,1.32,0,0,1,1.316,1.316Zm0-15.8a1.32,1.32,0,0,1-1.316,1.316h-23.7a1.32,1.32,0,0,1-1.316-1.316V48.71a1.32,1.32,0,0,1,1.316-1.316h23.7a1.32,1.32,0,0,1,1.316,1.316Zm0-15.8a1.32,1.32,0,0,1-1.316,1.316h-23.7a1.32,1.32,0,0,1-1.316-1.316V32.912A1.32,1.32,0,0,1,27.646,31.6h23.7a1.32,1.32,0,0,1,1.316,1.316Z"
        transform="translate(0)"
      />
    </g>
  </svg>
);

export const shows = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    transform={`translate(0, ${size / 7})`}
    viewBox="0 0 300 300"
  >
    <path
      style={{ fill: fill }}
      d="m14,21.38v169.21c0,3.79,2.76,7,6.5,7.6,27.53,4.43,50.61,11.6,68.47,18.41,30.28,11.52,44.76,14.54,61.55,14.54,17.9,0,29.61-5.38,66.02-18.42,14.65-5.24,35.95-11.57,62.63-14.78,3.86-.46,6.75-3.75,6.75-7.64V21.38c0-10.15-8.23-18.38-18.38-18.38H32.38c-10.15,0-18.38,8.23-18.38,18.38Zm213.36,75.61l-40.4,27.67c-2.84,1.95-4.04,5.55-2.94,8.81l15.56,46.11c.98,2.92-.58,6.07-3.49,7.05-.57.19-1.16.29-1.76.29-1.18.01-2.31-.35-3.27-1.04l-40.18-29.12c-2.69-1.95-6.34-1.95-9.03,0l-40.18,29.12c-2.49,1.81-5.97,1.26-7.77-1.23-1.07-1.46-1.34-3.34-.77-5.05l15.57-46.12c1.1-3.26-.1-6.86-2.94-8.81l-40.39-27.7c-2.53-1.73-3.18-5.19-1.45-7.73,1.04-1.51,2.75-2.41,4.57-2.41h50.16c3.33,0,6.29-2.15,7.32-5.32l15.1-46.46c.94-2.92,4.08-4.52,7-3.57,1.7.54,3.03,1.87,3.58,3.57l15.09,46.47c1.03,3.17,3.99,5.32,7.32,5.32h50.15c3.08,0,5.57,2.49,5.57,5.55,0,1.85-.9,3.56-2.41,4.6Z"
    />
  </svg>
);

export const location = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <circle cx="256" cy="192" r="32" style={{ fill: fill }} />
    <path
      style={{ fill: fill }}
      d="M256 32c-88.22 0-160 68.65-160 153 0 40.17 18.31 93.59 54.42 158.78 29 52.34 62.55 99.67 80 123.22a31.75 31.75 0 0051.22 0c17.42-23.55 51-70.88 80-123.22C397.69 278.61 416 225.19 416 185c0-84.35-71.78-153-160-153zm0 224a64 64 0 1164-64 64.07 64.07 0 01-64 64z"
    />
  </svg>
);

export const share = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <path
      style={{ fill: fill }}
      d="M384 336a63.78 63.78 0 00-46.12 19.7l-148-83.27a63.85 63.85 0 000-32.86l148-83.27a63.8 63.8 0 10-15.73-27.87l-148 83.27a64 64 0 100 88.6l148 83.27A64 64 0 10384 336z"
    />
  </svg>
);

export const cafe = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <path
      style={{ fill: fill }}
      d="M432 64H96a16 16 0 00-16 16v192a96.11 96.11 0 0096 96h112a96.11 96.11 0 0096-96v-80h18a62.07 62.07 0 0062-62V96a32 32 0 00-32-32zm0 66a30 30 0 01-30 30h-18V96h48zM400 400H64a16 16 0 000 32h336a16 16 0 000-32z"
    />
  </svg>
);

export const bicycle = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <path
      style={{ fill: fill }}
      d="M388 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zM124 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zM320 128a31.89 31.89 0 0032-32.1A31.55 31.55 0 00320.2 64a32 32 0 10-.2 64z"
    />
    <path
      style={{ fill: fill }}
      d="M367.55 192h-43.76a4 4 0 01-3.51-2.08l-31.74-58.17a31 31 0 00-49.38-7.75l-69.86 70.4a32.56 32.56 0 00-9.3 22.4c0 17.4 12.6 23.6 18.5 27.1 28.5 16.42 48.57 28.43 59.58 35.1a4 4 0 011.92 3.41v69.12c0 8.61 6.62 16 15.23 16.43A16 16 0 00272 352v-86a16 16 0 00-6.66-13l-37-26.61a4 4 0 01-.58-6l42-44.79a4 4 0 016.42.79L298 215.77a16 16 0 0014 8.23h56a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"
    />
  </svg>
);

export const sparkles = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <path
      style={{ fill: fill }}
      d="M208 512a24.84 24.84 0 01-23.34-16l-39.84-103.6a16.06 16.06 0 00-9.19-9.19L32 343.34a25 25 0 010-46.68l103.6-39.84a16.06 16.06 0 009.19-9.19L184.66 144a25 25 0 0146.68 0l39.84 103.6a16.06 16.06 0 009.19 9.19l103 39.63a25.49 25.49 0 0116.63 24.1 24.82 24.82 0 01-16 22.82l-103.6 39.84a16.06 16.06 0 00-9.19 9.19L231.34 496A24.84 24.84 0 01208 512zm66.85-254.84zM88 176a14.67 14.67 0 01-13.69-9.4l-16.86-43.84a7.28 7.28 0 00-4.21-4.21L9.4 101.69a14.67 14.67 0 010-27.38l43.84-16.86a7.31 7.31 0 004.21-4.21L74.16 9.79A15 15 0 0186.23.11a14.67 14.67 0 0115.46 9.29l16.86 43.84a7.31 7.31 0 004.21 4.21l43.84 16.86a14.67 14.67 0 010 27.38l-43.84 16.86a7.28 7.28 0 00-4.21 4.21l-16.86 43.84A14.67 14.67 0 0188 176zM400 256a16 16 0 01-14.93-10.26l-22.84-59.37a8 8 0 00-4.6-4.6l-59.37-22.84a16 16 0 010-29.86l59.37-22.84a8 8 0 004.6-4.6l22.67-58.95a16.45 16.45 0 0113.17-10.57 16 16 0 0116.86 10.15l22.84 59.37a8 8 0 004.6 4.6l59.37 22.84a16 16 0 010 29.86l-59.37 22.84a8 8 0 00-4.6 4.6l-22.84 59.37A16 16 0 01400 256z"
    />
  </svg>
);

export const addCircle = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <path
      style={{ fill: fill }}
      d="M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 224h-64v64a16 16 0 01-32 0v-64h-64a16 16 0 010-32h64v-64a16 16 0 0132 0v64h64a16 16 0 010 32z"
    />
  </svg>
);

export const navigate = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <path
      style={{ fill: fill }}
      d="M272 464a16 16 0 01-16-16.42V264.13a8 8 0 00-8-8H64.41a16.31 16.31 0 01-15.49-10.65 16 16 0 018.41-19.87l384-176.15a16 16 0 0121.22 21.19l-176 384A16 16 0 01272 464z"
    />
  </svg>
);

export const pencil = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <path
      style={{ fill: fill }}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="50"
      stroke={fill}
      d="M358.62 129.28L86.49 402.08 70 442l39.92-16.49 272.8-272.13-24.1-24.1zM413.07 74.84l-11.79 11.78 24.1 24.1 11.79-11.79a16.51 16.51 0 000-23.34l-.75-.75a16.51 16.51 0 00-23.35 0z"
    />
  </svg>
);

export const people = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <path
      style={{ fill: fill }}
      d="M336 256c-20.56 0-40.44-9.18-56-25.84-15.13-16.25-24.37-37.92-26-61-1.74-24.62 5.77-47.26 21.14-63.76S312 80 336 80c23.83 0 45.38 9.06 60.7 25.52 15.47 16.62 23 39.22 21.26 63.63-1.67 23.11-10.9 44.77-26 61C376.44 246.82 356.57 256 336 256zm66-88zM467.83 432H204.18a27.71 27.71 0 01-22-10.67 30.22 30.22 0 01-5.26-25.79c8.42-33.81 29.28-61.85 60.32-81.08C264.79 297.4 299.86 288 336 288c36.85 0 71 9 98.71 26.05 31.11 19.13 52 47.33 60.38 81.55a30.27 30.27 0 01-5.32 25.78A27.68 27.68 0 01467.83 432zM147 260c-35.19 0-66.13-32.72-69-72.93-1.42-20.6 5-39.65 18-53.62 12.86-13.83 31-21.45 51-21.45s38 7.66 50.93 21.57c13.1 14.08 19.5 33.09 18 53.52-2.87 40.2-33.8 72.91-68.93 72.91zM212.66 291.45c-17.59-8.6-40.42-12.9-65.65-12.9-29.46 0-58.07 7.68-80.57 21.62-25.51 15.83-42.67 38.88-49.6 66.71a27.39 27.39 0 004.79 23.36A25.32 25.32 0 0041.72 400h111a8 8 0 007.87-6.57c.11-.63.25-1.26.41-1.88 8.48-34.06 28.35-62.84 57.71-83.82a8 8 0 00-.63-13.39c-1.57-.92-3.37-1.89-5.42-2.89z"
    />
  </svg>
);

export const checkout = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 300 300"
    width={size}
    style={{ aspectRatio: "169/146" }}
  >
    <path
      style={{ fill: fill }}
      d="m246,38.08h-26.3v-8.78c-.03-14.51-11.8-26.28-26.31-26.3h-87.69c-14.52.03-26.29,11.79-26.31,26.3v8.78h-26.3c-19.36.01-35.06,15.71-35.08,35.07v122.77c0,19.39,15.7,35.08,35.08,35.08h192.92c19.39,0,35.08-15.7,35.08-35.08v-122.77c-.03-19.36-15.72-35.06-35.08-35.07Zm-149.08-8.78c0-4.84,3.93-8.77,8.78-8.77h87.69c4.85,0,8.77,3.93,8.77,8.77v8.78h-105.23v-8.78Zm53.89,146.42l-.19-34.96-77.77.43-.09-17.53,77.77-.44-.18-34.94,75.93,43.29-75.48,44.15Z"
    />
  </svg>
);

export const checkin = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    style={{ aspectRatio: "169/146" }}
    viewBox="0 0 300 300"
  >
    <path
      style={{ fill: fill }}
      d="m150.99,97.13c-8.97,0-16.22,7.27-16.22,16.21s7.28,16.22,16.22,16.22c4.49,0,8.54-1.8,11.48-4.74,2.94-2.94,4.74-7,4.74-11.49,0-8.96-7.25-16.21-16.21-16.21Zm0,21.49c-3.9,0-7.04-3.15-7.04-7.05s3.14-7.04,7.04-7.04,7.05,3.17,7.05,7.04-3.17,7.05-7.05,7.05Zm0-21.49c-8.97,0-16.22,7.27-16.22,16.21s7.28,16.22,16.22,16.22c4.49,0,8.54-1.8,11.48-4.74,2.94-2.94,4.74-7,4.74-11.49,0-8.96-7.25-16.21-16.21-16.21Zm0,21.49c-3.9,0-7.04-3.15-7.04-7.05s3.14-7.04,7.04-7.04,7.05,3.17,7.05,7.04-3.17,7.05-7.05,7.05Zm0-21.49c-8.97,0-16.22,7.27-16.22,16.21s7.28,16.22,16.22,16.22c4.49,0,8.54-1.8,11.48-4.74,2.94-2.94,4.74-7,4.74-11.49,0-8.96-7.25-16.21-16.21-16.21Zm0,21.49c-3.9,0-7.04-3.15-7.04-7.05s3.14-7.04,7.04-7.04,7.05,3.17,7.05,7.04-3.17,7.05-7.05,7.05Zm0-21.49c-8.97,0-16.22,7.27-16.22,16.21s7.28,16.22,16.22,16.22c4.49,0,8.54-1.8,11.48-4.74,2.94-2.94,4.74-7,4.74-11.49,0-8.96-7.25-16.21-16.21-16.21Zm0,21.49c-3.9,0-7.04-3.15-7.04-7.05s3.14-7.04,7.04-7.04,7.05,3.17,7.05,7.04-3.17,7.05-7.05,7.05Zm97.4-81.41h-26.7v-8.9c-.03-14.72-11.98-26.67-26.7-26.7h-89c-14.74.03-26.69,11.98-26.7,26.7v8.9h-26.7c-19.65.01-35.58,15.95-35.6,35.6v124.59c0,19.68,15.93,35.6,35.6,35.6h195.79c19.68,0,35.6-15.93,35.6-35.6v-124.59c-.03-19.65-15.95-35.59-35.6-35.6Zm-70.64,114.6c-6.1,10.81-12.87,21.23-20.27,31.22-.5.65-1.07,1.24-1.75,1.73-3.57,2.63-8.61,1.85-11.23-1.73-7.4-9.97-14.17-20.41-20.27-31.22-9.15-16.52-13.79-30.05-13.79-40.24,0-21.37,18.17-38.76,40.54-38.76s40.53,17.39,40.53,38.76c0,10.19-4.63,23.72-13.76,40.24Zm26.14-114.6h-106.81v-8.9c0-4.91,3.99-8.9,8.9-8.9h89c4.91,0,8.9,3.99,8.9,8.9v8.9Zm-52.91,59.92c-8.97,0-16.22,7.27-16.22,16.21s7.28,16.22,16.22,16.22c4.49,0,8.54-1.8,11.48-4.74,2.94-2.94,4.74-7,4.74-11.49,0-8.96-7.25-16.21-16.21-16.21Zm0,21.49c-3.9,0-7.04-3.15-7.04-7.05s3.14-7.04,7.04-7.04,7.05,3.17,7.05,7.04-3.17,7.05-7.05,7.05Zm0-21.49c-8.97,0-16.22,7.27-16.22,16.21s7.28,16.22,16.22,16.22c4.49,0,8.54-1.8,11.48-4.74,2.94-2.94,4.74-7,4.74-11.49,0-8.96-7.25-16.21-16.21-16.21Zm0,21.49c-3.9,0-7.04-3.15-7.04-7.05s3.14-7.04,7.04-7.04,7.05,3.17,7.05,7.04-3.17,7.05-7.05,7.05Zm0-21.49c-8.97,0-16.22,7.27-16.22,16.21s7.28,16.22,16.22,16.22c4.49,0,8.54-1.8,11.48-4.74,2.94-2.94,4.74-7,4.74-11.49,0-8.96-7.25-16.21-16.21-16.21Zm0,21.49c-3.9,0-7.04-3.15-7.04-7.05s3.14-7.04,7.04-7.04,7.05,3.17,7.05,7.04-3.17,7.05-7.05,7.05Z"
    />
  </svg>
);

export const alertCircle = (size = 24, fill = "var(--ion-color-primary)") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 512 512"
  >
    <path
      style={{ fill: fill }}
      d="M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 319.91a20 20 0 1120-20 20 20 0 01-20 20zm21.72-201.15l-5.74 122a16 16 0 01-32 0l-5.74-121.94v-.05a21.74 21.74 0 1143.44 0z"
    />
  </svg>
);

export const sortByIcon = (size, fill) => {
  return (
    <svg
      id="Layer_5"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      width={size}
      height={size}
      style={{ fill: fill }}
    >
      <path
        className="cls-1"
        d="m150.9,10.69l-57.12,118.21c-2.36,4.88,1.2,10.54,6.62,10.54h114.25c5.42,0,8.97-5.67,6.62-10.54L164.14,10.69c-2.67-5.53-10.56-5.53-13.23,0Z"
      />
      <path
        className="cls-1"
        d="m164.14,285.19l57.12-118.21c2.36-4.88-1.2-10.54-6.62-10.54h-114.25c-5.42,0-8.97,5.67-6.62,10.54l57.12,118.21c2.67,5.53,10.56,5.53,13.23,0Z"
      />
    </svg>
  );
};

export const chevronDownOutlined = (size, fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={size}
      height={size}
    >
      <path
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="48"
        d="M112 184l144 144 144-144"
      />
    </svg>
  );
};

export const calendarFilled = (size, fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 31.827 25"
    >
      <path
        id="Subtraction_8"
        data-name="Subtraction 8"
        d="M29.714,25H2.114A2.116,2.116,0,0,1,0,22.886V8.986a.529.529,0,0,1,.528-.528H31.3a.529.529,0,0,1,.528.528v13.9A2.116,2.116,0,0,1,29.714,25ZM8.246,18.927v1.8a7.292,7.292,0,0,0,2.885.54,4.844,4.844,0,0,0,2.987-.8,2.68,2.68,0,0,0,1.046-2.246,2.067,2.067,0,0,0-.622-1.576A3.2,3.2,0,0,0,12.71,15.9v-.041a2.95,2.95,0,0,0,1.593-.9,2.363,2.363,0,0,0,.567-1.593,2.025,2.025,0,0,0-.9-1.75,4.229,4.229,0,0,0-2.451-.629,5.454,5.454,0,0,0-3.261.985l.977,1.456a4.939,4.939,0,0,1,1.131-.568,3.281,3.281,0,0,1,1-.164c.943,0,1.421.382,1.421,1.135a1.1,1.1,0,0,1-.536,1.042,3.6,3.6,0,0,1-1.7.3H9.784V16.8h.76a4.261,4.261,0,0,1,1.832.294,1.036,1.036,0,0,1,.574,1,1.31,1.31,0,0,1-.5,1.141,2.7,2.7,0,0,1-1.545.355A5.387,5.387,0,0,1,9.525,19.4,6.558,6.558,0,0,1,8.246,18.927ZM19.43,13.355v0L19.4,14.395l-.021.95v5.783h2.112V11.134H19.751L16.531,13.7l1.019,1.272,1.148-.923c.136-.109.375-.334.73-.689ZM31.3,7.048H.528A.529.529,0,0,1,0,6.519V4.933A2.116,2.116,0,0,1,2.114,2.819H4.228V.528A.529.529,0,0,1,4.757,0H6.519a.529.529,0,0,1,.529.528V2.819H24.781V.528A.529.529,0,0,1,25.309,0H27.07A.529.529,0,0,1,27.6.528V2.819h2.114a2.116,2.116,0,0,1,2.114,2.114V6.519A.529.529,0,0,1,31.3,7.048Z"
        fill={fill}
      />
    </svg>
  );
};

export const diningFilled = (size, fill) => {
  return (
    <svg
      id="restaurant"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25.001"
    >
      <path
        id="Path_586"
        data-name="Path 586"
        d="M40.375,26.83a4.122,4.122,0,0,0,2.938-1.221l4-4.008a.851.851,0,0,0,.044-1.166.829.829,0,0,0-1.2-.029l-3.564,3.572a.637.637,0,0,1-.9,0,.659.659,0,0,1,.013-.919L45.248,19.5a.835.835,0,0,0-.029-1.206.81.81,0,0,0-.549-.211.867.867,0,0,0-.613.255l-3.545,3.555a.637.637,0,0,1-.9,0,.66.66,0,0,1,.013-.919l3.549-3.558a.835.835,0,0,0-.029-1.206A.81.81,0,0,0,42.592,16a.868.868,0,0,0-.613.255l-4,4.008a4.146,4.146,0,0,0-1.217,2.947v.429a.835.835,0,0,1-.244.59l-1.849,1.855a.207.207,0,0,1-.294,0l-9-9.025a.829.829,0,0,0-1.173,0A4.376,4.376,0,0,0,23,20.247a9.656,9.656,0,0,0,2.949,6.462l4.438,4.45a3.36,3.36,0,0,0,2.376.986,3.315,3.315,0,0,0,.842-.108.841.841,0,0,1,.211-.028.826.826,0,0,1,.562.221l.592.548a.841.841,0,0,1,.239.585v.289a2.49,2.49,0,0,0,.715,1.753L40.6,40.174l0,.005a2.772,2.772,0,1,0,3.914-3.925l-7.01-7.03a.209.209,0,0,1,0-.295l1.849-1.855a.83.83,0,0,1,.588-.244Z"
        transform="translate(-22.567 -16)"
        fill={fill}
      />
      <path
        id="Path_587"
        data-name="Path 587"
        d="M26.78,316a5.347,5.347,0,0,1-3.756-1.552l-.761-.761a.439.439,0,0,0-.621,0l-4.67,4.646a3.107,3.107,0,0,0-.718,3.257,1.681,1.681,0,0,0,.082.2,3.105,3.105,0,0,0,2.807,1.794,3.059,3.059,0,0,0,2.178-.9l6.228-6.258a.258.258,0,0,0,.073-.2V316.2a.254.254,0,0,0-.283-.235A5.333,5.333,0,0,1,26.78,316Z"
        transform="translate(-16.07 -298.576)"
        fill={fill}
      />
    </svg>
  );
};

export const activitiesFilled = (size, fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 31.999 30.278"
    >
      <g
        id="Group_3304"
        data-name="Group 3304"
        transform="translate(17456.307 17515.475)"
      >
        <path
          id="Subtraction_4"
          data-name="Subtraction 4"
          d="M7.458,30.278h0a6.947,6.947,0,0,1-3.535-.915,6.714,6.714,0,0,1-1.631-1.331,7.836,7.836,0,0,1-1.2-1.8,10.215,10.215,0,0,1-.761-2.19,13.531,13.531,0,0,1-.321-2.5A17.315,17.315,0,0,1,.132,18.8,20.977,20.977,0,0,1,.7,15.91,24.544,24.544,0,0,1,2.54,11.146l3.1,1.8a17.453,17.453,0,0,0-1.06,2.7A13.077,13.077,0,0,0,4,19.2a7.255,7.255,0,0,0,.5,2.911,3.8,3.8,0,0,0,1.581,1.878,3.61,3.61,0,0,0,1.838.473,5.735,5.735,0,0,0,2.164-.469,9.929,9.929,0,0,0,2.264-1.337,14.721,14.721,0,0,0,2.189-2.1,18.261,18.261,0,0,0,1.94-2.763,17.914,17.914,0,0,0,1.649-3.8A13.071,13.071,0,0,0,18.7,10.43a7.252,7.252,0,0,0-.5-2.911,3.805,3.805,0,0,0-1.581-1.878,3.61,3.61,0,0,0-1.837-.472,5.733,5.733,0,0,0-2.165.469,9.935,9.935,0,0,0-2.264,1.337,14.724,14.724,0,0,0-2.189,2.1A17.752,17.752,0,0,0,6.992,10.62L3.881,8.815a25.048,25.048,0,0,1,2.264-3A21.222,21.222,0,0,1,9.568,2.678,15.478,15.478,0,0,1,13.184.693,10.111,10.111,0,0,1,16.731,0a6.95,6.95,0,0,1,3.537.915A6.713,6.713,0,0,1,21.9,2.247a7.842,7.842,0,0,1,1.2,1.8,10.211,10.211,0,0,1,.761,2.19,13.544,13.544,0,0,1,.321,2.5,17.317,17.317,0,0,1-.121,2.737,20.978,20.978,0,0,1-.566,2.893,24.921,24.921,0,0,1-2.481,5.943,25.381,25.381,0,0,1-2.966,4.151A21.207,21.207,0,0,1,14.621,27.6,15.483,15.483,0,0,1,11,29.585,10.115,10.115,0,0,1,7.458,30.278ZM9.043,20.5a1.947,1.947,0,0,1-.99-.254,2.022,2.022,0,0,1-.809-.917,3.761,3.761,0,0,1-.32-1.424,8.778,8.778,0,0,1,.8-3.753l1.665.966a1.335,1.335,0,0,0,1.83-.493,1.352,1.352,0,0,0-.49-1.839l-1.674-.971A9.56,9.56,0,0,1,11.3,9.558a4.091,4.091,0,0,1,2.231-.828,1.946,1.946,0,0,1,.99.254,2.093,2.093,0,0,1,.889,1.106,4.4,4.4,0,0,1,.24,1.749,8.39,8.39,0,0,1-.4,2.156,11.75,11.75,0,0,1-1.029,2.326,10.755,10.755,0,0,1-2.536,3.044,6.1,6.1,0,0,1-1.364.842A3.262,3.262,0,0,1,9.043,20.5Z"
          transform="translate(-17448.496 -17515.475)"
          fill={fill}
        />
        <path
          id="Union_1"
          data-name="Union 1"
          d="M2.418,19.158V6.426L.272,5.169a.183.183,0,0,1-.09-.151L0,.189A.182.182,0,0,1,.27.022L3,1.519,5.735.022A.182.182,0,0,1,6,.189l-.182,4.83a.183.183,0,0,1-.09.151L3.511,6.47V19.158a.547.547,0,1,1-1.093,0Z"
          transform="translate(-17456.307 -17508.322) rotate(-60)"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const spaFilled = (size = 24, fill = "var(--ion-color-primary)") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 24.889"
    >
      <path
        id="Icon_awesome-spa"
        data-name="Icon awesome-spa"
        d="M31.569,11.139c-1.613.007-7.5.342-11.88,4.611A14.276,14.276,0,0,0,16,21.02a14.276,14.276,0,0,0-3.689-5.27c-4.379-4.269-10.267-4.6-11.88-4.611A.423.423,0,0,0,0,11.573,15.384,15.384,0,0,0,4.932,22.645,14.746,14.746,0,0,0,16,27.139a14.745,14.745,0,0,0,11.068-4.493A15.383,15.383,0,0,0,32,11.573a.423.423,0,0,0-.431-.434ZM16,17.283a15.285,15.285,0,0,1,2.449-2.807,16.626,16.626,0,0,1,3.348-2.51A18.325,18.325,0,0,0,16.422,2.4a.667.667,0,0,0-.841,0,18.326,18.326,0,0,0-5.374,9.559,16.333,16.333,0,0,1,3.29,2.466A15.709,15.709,0,0,1,16,17.283Z"
        transform="translate(0 -2.25)"
        fill={fill}
      />
    </svg>
  );
};

export const calendarOutlined = (size, fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
    >
      <g
        id="Group_3254"
        data-name="Group 3254"
        transform="translate(17453 2879)"
      >
        <path
          id="Subtraction_5"
          data-name="Subtraction 5"
          d="M20,36H5a5.006,5.006,0,0,1-5-5V16a5.006,5.006,0,0,1,5-5h6v3H5a2,2,0,0,0-2,2V31a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V25h3v6A5.006,5.006,0,0,1,20,36Z"
          transform="translate(-17453 -2890)"
          fill={fill}
        />
        <path
          id="Union_3"
          data-name="Union 3"
          d="M7,16a1,1,0,0,1-1-1V10H1A1,1,0,0,1,0,9V7A1,1,0,0,1,1,6H6V1A1,1,0,0,1,7,0H9a1,1,0,0,1,1,1V6h5a1,1,0,0,1,1,1V9a1,1,0,0,1-1,1H10v5a1,1,0,0,1-1,1Z"
          transform="translate(-17444 -2879)"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const viewOnMenu = (size, fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
    >
      <g
        id="Group_3290"
        data-name="Group 3290"
        transform="translate(14807 906)"
      >
        <g
          id="Group_3256"
          data-name="Group 3256"
          transform="translate(2608.875 1924)"
        >
          <path
            id="Subtraction_7"
            data-name="Subtraction 7"
            d="M20,36H5a5.006,5.006,0,0,1-5-5V16a5.006,5.006,0,0,1,5-5H7v3H5a2,2,0,0,0-2,2V31a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V27h3v4A5.006,5.006,0,0,1,20,36Z"
            transform="translate(-17415.875 -2841)"
            fill={fill}
          />
        </g>
        <rect
          id="Rectangle_2686"
          data-name="Rectangle 2686"
          width="16"
          height="4"
          rx="1"
          transform="translate(-14782 -902) rotate(180)"
          fill={fill}
        />
        <rect
          id="Rectangle_2687"
          data-name="Rectangle 2687"
          width="16"
          height="4"
          rx="1"
          transform="translate(-14782 -897) rotate(180)"
          fill={fill}
        />
        <rect
          id="Rectangle_2688"
          data-name="Rectangle 2688"
          width="16"
          height="4"
          rx="1"
          transform="translate(-14782 -892) rotate(180)"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const seeOnMap = (size, fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
    >
      <g
        id="Group_3256"
        data-name="Group 3256"
        transform="translate(17415.875 2830)"
      >
        <path
          id="Subtraction_7"
          data-name="Subtraction 7"
          d="M20,36H5a5.006,5.006,0,0,1-5-5V16a5.006,5.006,0,0,1,5-5h6v3H5a2,2,0,0,0-2,2V31a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V25h3v6A5.006,5.006,0,0,1,20,36Z"
          transform="translate(-17415.875 -2841)"
          fill={fill}
        />
        <path
          id="Icon_awesome-map-marked"
          data-name="Icon awesome-map-marked"
          d="M13.294,0A5.383,5.383,0,0,0,7.91,5.383c0,2.4,3.518,6.785,4.866,8.375a.674.674,0,0,0,1.034,0c1.348-1.59,4.866-5.971,4.866-8.375A5.383,5.383,0,0,0,13.294,0Z"
          transform="translate(-17409.553 -2830)"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const calendarItinerary = (
  size = 24,
  fill = "var(--ion-color-primary)"
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 25 25"
  >
    <g id="Group_3254" data-name="Group 3254" transform="translate(17453 2879)">
      <path
        id="Subtraction_5"
        data-name="Subtraction 5"
        d="M20,36H5a5.006,5.006,0,0,1-5-5V16a5.006,5.006,0,0,1,5-5h6v3H5a2,2,0,0,0-2,2V31a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V25h3v6A5.006,5.006,0,0,1,20,36Z"
        transform="translate(-17453 -2890)"
        fill={fill}
      />
      <path
        id="Union_3"
        data-name="Union 3"
        d="M7,16a1,1,0,0,1-1-1V10H1A1,1,0,0,1,0,9V7A1,1,0,0,1,1,6H6V1A1,1,0,0,1,7,0H9a1,1,0,0,1,1,1V6h5a1,1,0,0,1,1,1V9a1,1,0,0,1-1,1H10v5a1,1,0,0,1-1,1Z"
        transform="translate(-17444 -2879)"
        fill={fill}
      />
    </g>
  </svg>
);

export const shareItinerary = (size, fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
    >
      <g
        id="Group_3255"
        data-name="Group 3255"
        transform="translate(17489 2868)"
      >
        <path
          id="Subtraction_6"
          data-name="Subtraction 6"
          d="M20,36H5a5.006,5.006,0,0,1-5-5V16a5.006,5.006,0,0,1,5-5h6v3H5a2,2,0,0,0-2,2V31a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V25h3v6A5.006,5.006,0,0,1,20,36Z"
          transform="translate(-17489 -2879)"
          fill={fill}
        />
        <path
          id="Icon_ionic-md-share-alt"
          data-name="Icon ionic-md-share-alt"
          d="M23.564,14.3,15.621,6.75v4.237C8.207,12.046,5.559,17.341,4.5,22.637c2.648-3.707,5.825-5.4,11.121-5.4v4.343Z"
          transform="translate(-17487.564 -2874.75)"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const addNew = (size, fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
    >
      <g
        id="Group_3270"
        data-name="Group 3270"
        transform="translate(17415.875 2830)"
      >
        <path
          id="Subtraction_7"
          data-name="Subtraction 7"
          d="M20,36H5a5.006,5.006,0,0,1-5-5V16a5.006,5.006,0,0,1,5-5h6v3H5a2,2,0,0,0-2,2V31a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V25h3v6A5.006,5.006,0,0,1,20,36Z"
          transform="translate(-17415.875 -2841)"
          fill={fill}
        />
        <g
          id="Ellipse_187"
          data-name="Ellipse 187"
          transform="translate(-17401.875 -2830)"
          fill="none"
          stroke="#153246"
        >
          <circle cx="5.5" cy="5.5" r="5.5" stroke="none" />
          <circle cx="5.5" cy="5.5" r="4.25" fill="none" strokeWidth="2" />
        </g>
        <line
          id="Line_211"
          data-name="Line 211"
          x1="5"
          y2="5"
          transform="translate(-17405.375 -2820.5)"
          fill="none"
          stroke="#153246"
          strokeLinecap="round"
          strokeWidth="3"
        />
      </g>
    </svg>
  );
};

export const pdfIcon = (size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={size}
    viewBox="0 0 25 25"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_2723"
          data-name="Rectangle 2723"
          width="18"
          height="12"
          transform="translate(322 532)"
          fill="#811212"
        />
      </clipPath>
    </defs>
    <g id="icon_blue_pdf" transform="translate(-315 -532)">
      <g
        id="Group_3320"
        data-name="Group 3320"
        transform="translate(15122 1438)"
      >
        <g
          id="Group_3256"
          data-name="Group 3256"
          transform="translate(2608.875 1924)"
        >
          <path
            id="Subtraction_7"
            data-name="Subtraction 7"
            d="M20,36H5a5.006,5.006,0,0,1-5-5V16a5.006,5.006,0,0,1,5-5H7v3H5a2,2,0,0,0-2,2V31a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V23h3v8A5.006,5.006,0,0,1,20,36Z"
            transform="translate(-17415.875 -2841)"
            fill="#153246"
          />
        </g>
      </g>
      <g id="Mask_Group_35" data-name="Mask Group 35">
        <g id="Mask_Group_35" data-name="Mask Group 35">
          <g
            id="Component_7_1"
            data-name="Component 7 – 1"
            transform="translate(324 530)"
          >
            <text
              id="PDF"
              transform="translate(0 11)"
              fill="#153246"
              fontSize="11"
            >
              <tspan x="0" y="0">
                PDF
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
